import React, { useState } from 'react';
export function Footer() {
  const [activePolicy, setActivePolicy] = useState<string | null>(null);
  const policies: Record<string, string> = {
    'Política de Privacidad': `Política de Privacidad\n\nEn Cinnamon Rolls XL – Método XL Iconic, respetamos tu privacidad. Recopilamos únicamente la información necesaria para procesar tu compra y entregarte el producto digital (nombre, correo electrónico, datos de pago).\n\nNo compartimos tu información personal con terceros, excepto los proveedores de pago necesarios para completar la transacción.\n\nPuedes solicitar la eliminación de tus datos en cualquier momento escribiéndonos a nuestro correo de soporte.\n\nAl realizar tu compra, aceptas esta política de privacidad.`,
    'Términos y Condiciones': `Términos y Condiciones\n\nAl adquirir el producto digital "Cinnamon Rolls XL – Estilo New York – Edición Coleccionable", aceptas los siguientes términos:\n\n1. El producto es un archivo digital de descarga inmediata.\n2. El acceso es personal e intransferible.\n3. Queda prohibida la reproducción, distribución o reventa del contenido.\n4. Tienes 7 días naturales desde la compra para solicitar un reembolso completo si el producto no cumple tus expectativas.\n5. Nos reservamos el derecho de actualizar estos términos sin previo aviso.`,
    'Política de Reembolso': `Política de Reembolso\n\nOfrecemos una garantía de satisfacción de 7 días naturales.\n\nSi dentro de los primeros 7 días desde tu compra sientes que el contenido no te inspira o no puedes aplicarlo, te devolvemos el 100% de tu dinero. Sin preguntas.\n\nPara solicitar tu reembolso, simplemente escríbenos a nuestro correo de soporte con tu comprobante de compra.\n\nEl reembolso se procesará en un plazo de 5 a 10 días hábiles dependiendo de tu método de pago.`
  };
  return <>
      <footer className="py-12 px-4" style={{
      backgroundColor: '#1A1614'
    }} data-id="element-79">
        <div className="max-w-7xl mx-auto" data-id="element-80">
          <div className="w-full h-px mb-12" style={{
          background: 'linear-gradient(90deg, transparent, rgba(231,111,81,0.5), transparent)'
        }} data-id="element-81" />
          <div className="text-center mb-8" data-id="element-82">
            <p className="text-base font-bold tracking-[0.2em] uppercase mb-3" style={{
            color: '#F5EDE4'
          }} data-id="element-83">
              MÉTODO XL ICONIC
            </p>
            <p className="text-sm tracking-wide mb-8" style={{
            color: '#D4C4B0',
            opacity: 0.7
          }} data-id="element-84">
              Edición Coleccionable — Cinnamon Rolls XL
            </p>

            <div className="flex flex-wrap justify-center gap-6" data-id="element-85">
              {Object.keys(policies).map(name => <button key={name} onClick={() => setActivePolicy(name)} className="text-sm underline transition-colors duration-200 hover:opacity-100" style={{
              color: '#D4C4B0',
              opacity: 0.6
            }} data-id="element-86">
                  {name}
                </button>)}
            </div>
          </div>

          <p className="text-center text-xs" style={{
          color: '#D4C4B0',
          opacity: 0.4
        }} data-id="element-87">
            © {new Date().getFullYear()} Método XL Iconic. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      {/* Policy Popup */}
      {activePolicy && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{
      backgroundColor: 'rgba(0,0,0,0.6)'
    }} onClick={() => setActivePolicy(null)} data-id="element-88">
          <div className="bg-white rounded-3xl p-8 md:p-12 max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl relative" onClick={e => e.stopPropagation()} data-id="element-89">
            <button onClick={() => setActivePolicy(null)} className="absolute top-4 right-4 w-10 h-10 rounded-full flex items-center justify-center text-2xl font-bold transition-colors duration-200" style={{
          color: '#5a5248',
          backgroundColor: '#F5EDE4'
        }} data-id="element-90">
              ×
            </button>

            <h3 className="text-2xl md:text-3xl font-bold mb-6" style={{
          color: '#1A1614'
        }} data-id="element-91">
              {activePolicy}
            </h3>

            <div className="space-y-4" data-id="element-92">
              {policies[activePolicy].split('\n\n').map((paragraph, i) => <p key={i} className="text-base leading-relaxed" style={{
            color: '#5a5248'
          }} data-id="element-93">
                  {paragraph}
                </p>)}
            </div>

            <button onClick={() => setActivePolicy(null)} className="mt-8 font-bold py-3 px-8 rounded-full transition-all duration-200" style={{
          backgroundColor: '#e76f51',
          color: '#ffffff'
        }} onMouseEnter={e => {
          e.currentTarget.style.backgroundColor = '#f08565';
        }} onMouseLeave={e => {
          e.currentTarget.style.backgroundColor = '#e76f51';
        }} data-id="element-94">
              Cerrar
            </button>
          </div>
        </div>}
    </>;
}